import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";
import { useMutation } from "@tanstack/react-query";

const resendVerificationEmailMutation = graphql(/* GraphQL */ `
	mutation ResendVerificationEmail {
		user {
			resendVerificationEmail
		}
	}
`);

async function resendVerificationEmailFn() {
	const client = getApiClient();
	const result = await client.mutate({
		mutation: resendVerificationEmailMutation,
	});
	const resendResult = result.data?.user.resendVerificationEmail;

	if (typeof resendResult !== "boolean") {
		throw new Error("Invalid resend verification response");
	}

	return resendResult;
}

export function useResendVerificationEmail() {
	return useMutation({
		mutationFn: resendVerificationEmailFn,
	});
}
